import React, { useState } from "react"
import { Link } from "gatsby"
import { useMenuQuery } from "../../hooks/use-menu-query"
import styled from "@emotion/styled/macro"
import { css } from "@emotion/react"
import { Theme2 } from "../Layout"
import { useCommonItemsQuery } from "../../hooks/use-common-items-query"
import { RightRedArrow, Call } from "../SVGs"
import { Modal } from "../Modal"
import { HomeFormContainer } from "../HomeFormContainer"

const NavContainer = styled.div`
  background-color: ${Theme2.colors.dark1};
  position: relative;
  letter-spacing: 1px;

  ul {
    margin-left: 0;
    list-style: none;
  }
  li {
    margin: 0;
  }
  a {
    color: ${Theme2.colors.light};
    text-decoration: none;
  }
  .topLevel {
    display: flex;
    align-content: stretch;
    justify-content: center;
    max-width: 1722px;
    margin: 0 auto;
    font-size: 13px;
    font-weight: 500;
    overflow-x: hidden;

    @media (min-width: 1224px) {
      font-size: 20px;
    }
  }
  .topLevelLi {
    background: ${Theme2.colors.dark2};
    text-transform: uppercase;
    display: flex;
    align-items: stretch;
    justify-content: center;
    margin: 0;
    padding: 0 10px;
    box-sizing: border-box;

    a {
      min-width: 100%;
      flex-shrink: 0;
      padding: 28px 10px;
      box-sizing: border-box;
      &:hover {
        cursor: pointer;
      }
      @media (min-width: 1486px) {
        padding: 28px 30px;
      }
    }
    &:hover {
      background: ${Theme2.colors.light2};
      @media (min-width: 1486px) {
        background: linear-gradient(
          100deg,
          ${Theme2.colors.dark2} 15%,
          ${Theme2.colors.light2} 15%,
          ${Theme2.colors.light2} 85%,
          ${Theme2.colors.dark2} 85%
        );
        background-size: cover;
      }
    }
    &:hover a {
      color: ${Theme2.colors.dark1};
    }

    &:hover .secondLevel a {
      color: ${Theme2.colors.light};
      &:hover {
        color: ${Theme2.colors.dark1};
        background-color: ${Theme2.colors.light};
      }
    }
    &:hover .thirdLevel a {
      color: ${Theme2.colors.neutral};
    }
  }
  .buttonContainer {
    display: flex;
    margin: 0;
  }

  .freeConsult {
    appearance: none;
    flex-shrink: 0;
    padding: 28px 40px;
    appearance: none;
    border: none;
    background: linear-gradient(
      100deg,
      ${Theme2.colors.dark2} 10%,
      ${Theme2.colors.tertiary} 10%,
      ${Theme2.colors.tertiary} 90%,
      ${Theme2.colors.dark2} 90%
    );
    background-size: cover;
    color: ${Theme2.colors.light};
    text-transform: uppercase;
    letter-spacing: 1px;
    font-size: 13px;
    font-weight: 500;
    position: relative;
    box-sizing: border-box;
    @media (min-width: 1224px) {
      font-size: 20px;
    }

    @media (min-width: 1486px) {
      margin-right: 40px;
    }
    &:hover {
      cursor: pointer;
    }
  }
  .secondLevel {
    position: relative;
    padding: 0 3em;
    display: none;
    overflow-x: visible;
    width: 100%;

    a {
      padding: 7px 20px 7px 10px;
    }

    .nav-text {
      padding: 10px 0;
      letter-spacing: 0;
      font-size: 18px;
      text-transform: none;
      font-weight: 600;
    }
  }
  .secondLevel.notHidden {
    display: block;
  }
  .thirdLevel {
    .nav-text {
      padding: 20px 0;
    }
  }
  .fourthLevel {
    .nav-text {
      padding: 20px 0;
    }
  }

  .thirdLevel a,
  .fourthLevel a {
    color: ${Theme2.colors.neutral};
    text-transform: none;
  }
  .imageHolder {
    display: flex;
    align-items: stretch;
    width: 25%;
  }
  .nav-text {
    button {
      appearance: none;
      border: none;
      background-color: transparent;
      position: relative;
      svg {
        position: absolute;
        top: -10px;
      }
    }
  }

  .innerGrid {
    position: relative;
    max-width: 100vw;
    overflow-x: hidden;
    margin: 20px 0;
    display: flex;
    flex-direction: column;
    align-content: space-between;
    height: 100%;
  }

  .innerInnerUL {
    width: 100%;
    overflow-y: auto;
    overflow-x: visible;
    box-sizing: border-box;
    display: none;
  }
  .innerInnerUL.notHidden {
    display: block;
  }
  .thirdLevelUL {
    position: relative;
    overflow-x: visible;
    padding-left: 20px;
  }
  .fourthLevelUL {
    position: absolute;
    left: 50%;
    top: 0;
    max-height: 500px;
    overflow-y: auto;
    min-width: 40%;

    &::-webkit-scrollbar {
      width: 10px;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px ${Theme2.colors.light};
      border-radius: 10px;
      background-color: ${Theme2.colors.light};
    }

    &::-webkit-scrollbar-thumb {
      background: ${Theme2.colors.tertiary};
      border-radius: 10px;
    }
  }
  .thirdLevelUL,
  .fourthLevelUL {
    display: none;
  }
  .thirdLevelUL.notHidden,
  .fourthLevelUL.notHidden {
    display: block;
  }

  .arrowHolder {
    position: relative;

    .arrow {
      position: absolute;
      right: 5px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .mobileMenuButtonsContainer {
    display: grid;
    justify-content: center;
    grid-row-gap: 20px;
    margin-top: 50px;
    justify-content: flex-start;
    align-items: flex-end;
    align-self: flex-end;
  }
  .phoneButton {
    background-color: ${Theme2.colors.light2};
    color: ${Theme2.colors.dark1} !important;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 290px;
    padding: 18px !important;
    box-sizing: border-box;
    font-size: 23px;

    svg {
      margin-right: 24px;
    }
  }
  .freeConsultMobile {
    background-color: ${Theme2.colors.tertiary} !important;
    text-transform: uppercase;
    color: ${Theme2.colors.light};
    text-align: center;
    padding: 18px !important;
    font-size: 16px;
    appearance: none;
    border: none;
    width: 290px;
    display: inline-block;
    box-sizing: border-box;

    &:hover {
      cursor: pointer;
    }
  }
  .mobileMenuButtonsOuterContainer {
    flex: 0.75;
    display: flex;
    flex-direction: row;
  }
  .megaMenuTitleLink {
    margin-bottom: 7px;
    font-size: 1.1rem;
    color: ${Theme2.colors.light};
    display: flex;
  }
  .noHover {
    a:hover {
      background-color: transparent !important;
      color: ${Theme2.colors.light} !important;
      cursor: default;
    }
  }

  .second-level a {
    font-size: 22px;
  }
  .second-level {
    width: 100%;
  }
  .third-level a,
  .fourth-level a {
    font-size: 18px;
  }
  .third-level {
    overflow-x: visible;
    width: 100%;
  }
  .menuLink {
    color: ${Theme2.colors.light};
    padding: 28px 10px;
    flex-shrink: 0;
    margin-bottom: 0;
    line-height: 1;

    @media (min-width: 1486px) {
      padding: 28px 30px;
    }
  }
  .submenuLink {
    color: ${Theme2.colors.light};
    padding: 7px 20px 7px 10px;
    flex-shrink: 0;
    margin-bottom: 0;
    margin-block-start: 0;
    margin-block-end: 0;
    line-height: 1;
    font-size: 22px;
    &:hover {
      color: ${Theme2.colors.dark1};
      background-color: ${Theme2.colors.light};
    }
  }
  .submenuLink2 {
    font-size: 18px;
  }
`

const NavDesktop = () => {
  const [modalOpen, setModalOpen] = useState(false)
  const modalContent = <HomeFormContainer />
  const {
    commonItemsHeaderButtonText,
    commonItemsTopBarTextMobile,
    commonItemsOffices,
  } = useCommonItemsQuery()
  const [isHidden, setIsHidden] = useState(-1)
  //const [isHidden, setIsHidden] = useState(3)

  const [isHidden2, setIsHidden2] = useState(-1)
  //const [isHidden2, setIsHidden2] = useState(1)

  const [isHidden3, setIsHidden3] = useState(-1)
  //const [isHidden3, setIsHidden3] = useState(1)

  const tel = "tel:"
  const phoneNumber = commonItemsOffices[0].commonItemsPhone
  const phoneNumberHref = tel + phoneNumber

  const data = useMenuQuery()

  return (
    <>
      <NavContainer>
        <nav className="nav-menu active">
          <ul className="nav-menu-items topLevel">
            {data.nodes.map((menuItem, i) => {
              return (
                <>
                  {menuItem.childItems.nodes.length ? (
                    <li
                      key={menuItem.label}
                      onMouseEnter={() => setIsHidden(i)}
                      onMouseLeave={() => {
                        setIsHidden(-1)
                        setIsHidden2(-1)
                        setIsHidden3(-1)
                      }}
                      className="nav-text topLevelLi"
                    >
                      <p className="menuLink">{menuItem.label}</p>
                      <div
                        css={css`
                          ${i === isHidden
                            ? `display: flex; justify-content: center;`
                            : `display: none;`}

                          position: absolute;

                          top: 5em;
                          left: 0;
                          padding: 2em;
                          background-color: ${Theme2.colors.primary};
                          width: 100%;
                          box-sizing: border-box;

                          @media (min-width: 1224px) {
                            top: 3.75em;
                          }
                        `}
                      >
                        <div
                          css={css`
                            display: flex;
                            max-width: 1722px;
                          `}
                        >
                          {menuItem.label === "About Us" && (
                            <div className="imageHolder">
                              <img
                                srcSet={
                                  menuItem.menu.node.dropdownpics
                                    .dropdownPics[0].dropdownPic.localFile
                                    .childImageSharp.gatsbyImageData.images
                                    .sources[1].srcSet
                                }
                                width="100%"
                                alt={
                                  menuItem.menu.node.dropdownpics
                                    .dropdownPics[0].dropdownAltText
                                }
                                loading="eager"
                              />
                            </div>
                          )}
                          {menuItem.label === "Practice Areas" && (
                            <div className="imageHolder">
                              <img
                                srcSet={
                                  menuItem.menu.node.dropdownpics
                                    .dropdownPics[1].dropdownPic.localFile
                                    .childImageSharp.gatsbyImageData.images
                                    .sources[1].srcSet
                                }
                                width="100%"
                                alt={
                                  menuItem.menu.node.dropdownpics
                                    .dropdownPics[1].dropdownAltText
                                }
                                loading="eager"
                              />
                            </div>
                          )}
                          {menuItem.label === "Resources" && (
                            <div className="imageHolder">
                              <img
                                srcSet={
                                  menuItem.menu.node.dropdownpics
                                    .dropdownPics[2].dropdownPic.localFile
                                    .childImageSharp.gatsbyImageData.images
                                    .sources[1].srcSet
                                }
                                width="100%"
                                alt={
                                  menuItem.menu.node.dropdownpics
                                    .dropdownPics[2].dropdownAltText
                                }
                                loading="eager"
                              />
                            </div>
                          )}

                          <ul
                            className={`secondLevel ${
                              i === isHidden && `notHidden`
                            }`}
                          >
                            <li className="megaMenuTitleLink">
                              <ul>
                                {menuItem.childItems.nodes.map(
                                  (secondLevel, i2) => {
                                    return (
                                      <>
                                        <li
                                          key={secondLevel.label}
                                          className="nav-text second-level"
                                          onMouseEnter={() => {
                                            setIsHidden2(i2)
                                          }}
                                        >
                                          {secondLevel.childItems.nodes.length >
                                          0 ? (
                                            <p className="submenuLink arrowHolder">
                                              {secondLevel.label}
                                              <RightRedArrow className="arrow" />
                                            </p>
                                          ) : (
                                            <Link to={secondLevel.path}>
                                              {secondLevel.label}
                                            </Link>
                                          )}
                                        </li>
                                      </>
                                    )
                                  }
                                )}
                                <li>
                                  <ul className="mobileMenuButtonsContainer">
                                    <li key="4">
                                      <button
                                        onClick={() => setModalOpen(true)}
                                        className="freeConsultMobile"
                                      >
                                        {commonItemsTopBarTextMobile}
                                      </button>
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                              <div
                                css={css`
                                  flex-grow: 1;
                                `}
                              >
                                {menuItem.childItems.nodes.map(
                                  (secondLevel, i2) => {
                                    return (
                                      <ul
                                        className={`thirdLevelUL ${
                                          i2 === isHidden2 && `notHidden`
                                        }`}
                                      >
                                        {secondLevel.childItems.nodes.map(
                                          (thirdLevel, i3) => {
                                            return (
                                              <>
                                                <div
                                                  css={css`
                                                    display: grid;
                                                    grid-template-columns: 1fr;
                                                    width: 40%;
                                                  `}
                                                >
                                                  <li
                                                    key={thirdLevel.label}
                                                    className="nav-text"
                                                    onMouseEnter={() => {
                                                      setIsHidden3(i3)
                                                    }}
                                                  >
                                                    {thirdLevel.childItems.nodes
                                                      .length > 0 ? (
                                                      <p className="submenuLink submenuLink2 arrowHolder">
                                                        {thirdLevel.label}
                                                        <RightRedArrow className="arrow" />
                                                      </p>
                                                    ) : (
                                                      <Link
                                                        to={thirdLevel.path}
                                                      >
                                                        {thirdLevel.label}
                                                      </Link>
                                                    )}
                                                  </li>
                                                </div>
                                                <ul
                                                  className={`fourthLevelUL ${
                                                    i3 === isHidden3 &&
                                                    `notHidden`
                                                  }`}
                                                >
                                                  {thirdLevel.childItems.nodes
                                                    .length > 0 &&
                                                    thirdLevel.childItems.nodes.map(
                                                      fourthLevel => {
                                                        return (
                                                          <li
                                                            key={
                                                              fourthLevel.label
                                                            }
                                                            className="nav-text fourth-level"
                                                          >
                                                            <Link
                                                              to={
                                                                fourthLevel.path
                                                              }
                                                            >
                                                              {
                                                                fourthLevel.label
                                                              }
                                                            </Link>
                                                          </li>
                                                        )
                                                      }
                                                    )}
                                                </ul>
                                              </>
                                            )
                                          }
                                        )}
                                      </ul>
                                    )
                                  }
                                )}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                  ) : (
                    <li key={menuItem.label} className="nav-text topLevelLi">
                      <Link to={menuItem.path}>{menuItem.label}</Link>
                    </li>
                  )}
                </>
              )
            })}

            <li className="buttonContainer">
              <button
                onClick={() => setModalOpen(true)}
                className="freeConsult"
              >
                {commonItemsHeaderButtonText}
              </button>
            </li>
          </ul>
        </nav>
      </NavContainer>
      <Modal
        onClose={() => setModalOpen(false)}
        modalOpen={modalOpen}
        modalContent={modalContent}
      />
    </>
  )
}
export default NavDesktop
